import { Button } from '@mui/material';
import { Fragment, memo, useState } from 'react';
import CalculatorDrawer from './CalculatorDrawer';

const Calculator = () => {
  const [openDrawer, setOpenDrawer] = useState(false);

  return (
    <Fragment>
      <Button
        variant='base'
        size='small'
        sx={{ padding: '6px 12px', marginLeft: 1 }}
        onClick={() => setOpenDrawer(true)}
      >
        <i className='bi bi-calculator text-lg' />
      </Button>

      <CalculatorDrawer open={openDrawer} setOpen={setOpenDrawer} />
    </Fragment>
  );
};
export default memo(Calculator);
